export enum CustomFieldTarget {
    Evaluation = 'evaluation'
}